import axios from 'axios';
import authHeader from './auth-header';
import sidebarPlugin from "../components/SidebarPlugin";

const API_URL = 'https://gateway.mytalus.ch';

class UserService {
    getIncident(id) {
        return axios.get(API_URL + `/incidents/${id}`, {headers: authHeader()});
    }

    getAttachment(incidentId, attachmentId) {
        return axios.get(API_URL + `/incidents/${incidentId}/attachments/${attachmentId}`, {headers: authHeader(), responseType: 'blob'});
    }

    getIncidents(
        start = 0,
        perPage = 5,
        status = null,
        closed = null,
        search = null,
        sort = null,
        callers = null,
        operators = null,
        targetYear = null,
        targetMonth = null,
        categories = null) {
        return axios.get(API_URL + "/incidents", {
            headers: authHeader(),
            params: {
                start: start,
                length: perPage,
                status: status,
                closed: closed,
                search: search,
                orderBy: (sort) ? sort.prop + ':' + sort.order : '',
                callers: callers,  // filter by Ersteller
                operators: operators, // filter by Bearbeiter,
                targetYear: targetYear,
                targetMonth: targetMonth,
                categories: categories
            }
        });
    }

    getAssets() {
        return axios.get(API_URL + "/assets", {headers: authHeader()});
    }

    getFilters() {
        return axios.get(API_URL + "/filters", {headers: authHeader()});
    }

    getEmployees() {
        return axios.get(API_URL + `/employees`, {headers: authHeader()});
    }

    getCustomers() {
        return axios.get(API_URL + `/addresses`, {headers: authHeader()});
    }

    getCustomer(id, admin = false) {
        return axios.get(API_URL + `/addresses/${id}?admin=${admin}`, {headers: authHeader()});
    }

    getUsers() {
        return axios.get(API_URL + `/users`, {headers: authHeader()});
    }

    getUser(id) {
        return axios.get(API_URL + `/user/${id}`, {headers: authHeader()});
    }

    getSupervisors() {
        return axios.get(API_URL + `/supervisors`, {headers: authHeader()});
    }

    getContacts() {
        return axios.get(API_URL + `/contacts`, {headers: authHeader()});
    }

    getServices() {
        return axios.get(API_URL + `/services`, {headers: authHeader()});
    }

    getInvoices() {
        return axios.get(API_URL + `/invoices`, {headers: authHeader()});
    }

    getInvoice(id) {
        return axios.get(API_URL + `/invoices/${id}`, {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

    getInvoiceREST(id) {
        return axios.get(API_URL + `/invoices1/${id}`, {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

    getContracts() {
        return axios.get(API_URL + `/contracts`, {headers: authHeader()});
    }

    getContract(id, fId) {
        return axios.get(API_URL + `/contracts/${id}/${fId}`, {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

    getContractREST(id, fId) {
        return axios.get(API_URL + `/contracts1/${id}/${fId}`, {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

    getSubscription() {
        return axios.get(API_URL + `/subscription`, {headers: authHeader()});
    }

    getCategories() {
        return axios.get(API_URL + "/categories", {headers: authHeader()});
    }

    getBranches() {
        return axios.get(API_URL + "/branches", {headers: authHeader()});
    }

    getRoles() {
        return axios.get(API_URL + "/roles", {headers: authHeader()});
    }

    getRolesOfUser(id) {
        return axios.get(API_URL + `/users/${id}/roles`, {headers: authHeader()});
    }

    getClients() {
        return axios.get(API_URL + "/addresses", {headers: authHeader()});
    }

    getLicenses(month, comparison = false) {
        return axios.get(API_URL + `/licenses/${month}`, {
            headers: authHeader(),
            params: {
                comparison: +comparison,
            }
        });
    }

    generateToken(id) {
        const data = {
            length: 6
        };
        return axios.put(API_URL + `/users/${id}/token`, data, {headers: authHeader()});
    }

    setWidgets(widgetsArray) {
        let string = widgetsArray.map(item => JSON.stringify(item))
        if (widgetsArray.length === 0) {
            string = "NO";
        }
        const data = {
            widgets: string
        };
        return axios.put(API_URL + `/widgets`, data, {headers: authHeader()});
    }

    setRoles(id, roles) {
        const data = {
            roles: roles
        };
        return axios.put(API_URL + `/users/${id}/roles`, data, {headers: authHeader()});
    }

    getBranchesOfUser(assigneeUserId) {
        return axios.get(API_URL + `/users/${assigneeUserId}/branch_attributes`, {headers: authHeader()} )
    }

    setAsTopDeskUser(currentUserId, assigneeUserId) {
        const data = {
            assigneeUserId
        }
        return axios.put(API_URL + `/users/${currentUserId}/assignBranch`, data, {headers: authHeader()})
    }

    simulateClientId(id) {
        const data = {
            id: id
        };
        return axios.put(API_URL + `/simulate`, data, {headers: authHeader()});
    }

    switchClient(id) {
        const data = {
            id: id
        };
        return axios.put(API_URL + `/switch`, data, {headers: authHeader()});
    }

    setAdmin(id) {
        const data = {
            id: id
        };
        return axios.put(API_URL + `/users/${id}/admin`, data, {headers: authHeader()});
    }

    createClients(clients) {
        const data = {
            clients: clients
        };
        return axios.post(API_URL + `/clients`, data, {
                headers: authHeader()
            }
        );
    }

    createUsers(users, roles, clientId) {
        const data = {
            clientId: clientId,
            users: users,
            roles: roles
        };
        return axios.post(API_URL + `/users`, data, {
                headers: authHeader()
            }
        );
    }

    getRioNetCategories() {
        return axios.get(API_URL + "/rionet/categories", {headers: authHeader()});
    }

    createDownloadCategory(name) {
        const data = new FormData();
        data.append('name', name);
        return axios.post(API_URL + `/files/categories`, data, {
                headers: authHeader()
            }
        );
    }

    updateDownloadCategory(id, name) {
        const data = new FormData();
        data.append('name', name);
        return axios.put(API_URL + `/files/categories/${id}`, data, {
                headers: authHeader()
            }
        );
    }

    deleteDownloadCategory(id) {
        return axios.delete(API_URL + `/files/categories/${id}`, {headers: authHeader()});
    }

    getDownloadCategories() {
        return axios.get(API_URL + "/files/categories", {headers: authHeader()});
    }

    getDownloads() {
        return axios.get(API_URL + "/files/downloads", {headers: authHeader()});
    }

    forceDownload(id) {
        return API_URL + `/files/download/${id}`;
    }

    getDownload(id) {
        return axios.get(API_URL + `/files/download/${id}`, {
            headers: authHeader(),
            responseType: 'blob'
        });
    }

    createDownloads(files, links, categories, sections, clients, branches, folders, description, users) {
        const data = new FormData();
        for (let f = 0; f < files.length; f++) {
            data.append('file[]', files[f])
        }
        for (let fo = 0; fo < folders.length; fo++) {
            data.append('folders[]', folders[fo])
        }
        for (let l = 0; l < links.length; l++) {
            data.append('links[]', links[l])
        }
        for (let c = 0; c < categories.length; c++) {
            data.append('categories[]', categories[c]);
        }
        for (let s = 0; s < sections.length; s++) {
            data.append('sections[]', sections[s]);
        }
        for (let cl = 0; cl < clients.length; cl++) {
            data.append('clients[]', clients[cl]);
        }
        for (let b = 0; b < branches.length; b++) {
            data.append('branches[]', branches[b]);
        }
        for (let u = 0; u < users.length; u++) {
            data.append('users[]', users[u]);
        }
        data.append('description', description);
        return axios.post(API_URL + `/files/downloads`, data, {
            headers: authHeader()
        });
    }

    updateDownload(entry, isLink, categories, sections, clients, branches, folders, description, users) {
        const data = new FormData();
	data.append('isArchive', entry.isArchive);
        data.append('displayName', entry.displayName);
        for (let f = 0; f < folders.length; f++) {
            data.append('folders[]', folders[f])
        }
        for (let c = 0; c < categories.length; c++) {
            data.append('categories[]', categories[c]);
        }
        for (let s = 0; s < sections.length; s++) {
            data.append('sections[]', sections[s]);
        }
        for (let cl = 0; cl < clients.length; cl++) {
            data.append('clients[]', clients[cl]);
        }
        for (let b = 0; b < branches.length; b++) {
            data.append('branches[]', branches[b]);
        }
        for (let u = 0; u < users.length; u++) {
            data.append('users[]', users[u]);
        }
        data.append('description', description);
        if (isLink) {
            return axios.put(API_URL + `/files/links/${entry['_id']}`, data, {
                headers: authHeader()
            });
        } else {
            return axios.put(API_URL + `/files/files/${entry['_id']}`, data, {
                headers: authHeader()
            });
        }
    }

    archiveDownload(entry, isLink) {
        const data = new FormData();
        entry.users = (entry.users) ? entry.users : [];
        data.append('isArchive', entry.isArchive);
        data.append('displayName', entry.displayName);
        data.append('description', entry.description);
        for (let f = 0; f < entry.folders.length; f++) {
            data.append('folders[]', entry.folders[f])
        }
        for (let c = 0; c < entry.categories.length; c++) {
            data.append('categories[]', entry.categories[c]);
        }
        for (let s = 0; s < entry.sections.length; s++) {
            data.append('sections[]', entry.sections[s]);
        }
        for (let cl = 0; cl < entry.clients.length; cl++) {
            data.append('clients[]', clients[cl]);
        }
        for (let b = 0; b < entry.branches.length; b++) {
            data.append('branches[]', entry.branches[b]);
        }
        for (let u = 0; u < entry.users.length; u++) {
            data.append('users[]', entry.users[u]);
        }
        if (isLink) {
            return axios.put(API_URL + `/files/links/${entry['_id']}`, data, {
                headers: authHeader()
            });
        } else {
            return axios.put(API_URL + `/files/files/${entry['_id']}`, data, {
                headers: authHeader()
            });
        }
    }

    deleteDownload(id, isLink) {
        if (isLink) {
            return axios.delete(API_URL + `/files/links/${id}`, {headers: authHeader()});
        } else {
            return axios.delete(API_URL + `/files/files/${id}`, {headers: authHeader()});
        }
    }

    getFolders() {
        return axios.get(API_URL + "/files/folders", {headers: authHeader()});
    }

    createFolder(text, parent, children, sections, clients, branches) {
        const data = new FormData();
        data.append('text', text);
        data.append('parent', parent);
        for (let c = 0; c < children.length; c++) {
            data.append('children[]', children[c]);
        }
        for (let s = 0; s < sections.length; s++) {
            data.append('sections[]', sections[s]);
        }
        for (let cl = 0; cl < clients.length; cl++) {
            data.append('clients[]', clients[cl]);
        }
        for (let b = 0; b < branches.length; b++) {
            data.append('branches[]', branches[b]);
        }
        return axios.post(API_URL + `/files/folders`, data, {
            headers: authHeader()
        });
    }

    updateFolder(folder) {
        const data = new FormData();
        data.append('text', folder.text);
        return axios.put(API_URL + `/files/folders/${folder._id}`, data, {
            headers: authHeader()
        });
    }

    deleteFolder(id) {
        return axios.delete(API_URL + `/files/folders/${id}`, {headers: authHeader()});
    }

    getRioNetNews() {
        return axios.get(API_URL + "/rionet/news", {headers: authHeader()});
    }

    getRioNetArchive() {
        return axios.get(API_URL + "/rionet/archive", {headers: authHeader()});
    }

    archiveNewsEntry(id) {
        const data = {
            id: id
        };
        return axios.put(API_URL + `/rionet/archive`, data, {
                headers: authHeader()
            }
        );
    }

    createNewsEntry(newsEntry, categories) {
        const data = {
            title: newsEntry.title,
            teaser: newsEntry.teaser,
            content: newsEntry.content,
            categories: categories,
        };

        return axios.post(API_URL + `/rionet/news`, data, {
                headers: authHeader()
            }
        );
    }

    deleteNewsEntry(id) {
        return axios.delete(API_URL + `/rionet/news/${id}`, {headers: authHeader()});
    }

    getRioNumbers() {
        return axios.get(API_URL + "/rionet/numbers", {headers: authHeader()});
    }

    sendNFactor($data) {
        return axios.post(API_URL + "/rionet/nfactor", $data,{headers: authHeader()});
    }

    createRioNumber(number) {
        const data = {
            number: number,
        };
        return axios.post(API_URL + `/rionet/numbers`, data, {
                headers: authHeader()
            }
        );
    }

    deleteRioNumber(id) {
        return axios.delete(API_URL + `/rionet/numbers/${id}`, {headers: authHeader()});
    }

    createIncident(briefDescription, request, category, subCategory, files) {
        if (files) {
            for (const file of files) {
                if (file.size >= 2097152) {
                    throw new Error('Die Datei ist zu groß. Die maximale Dateigrösse beträgt 2MB');
                }
            }
        }

        const data = {
            request: request,
            category: (category === "") ? null : {id: category},
            subcategory: (subCategory === "") ? null : {id: subCategory},
            entryType: {name: 'Webinterface'},
            briefDescription: briefDescription
        };

        return axios.post(API_URL + `/incidents`, data, {
                headers: authHeader()
            }
        );
    }

    getSingleAttachment(incidentId, attachmentId) {
        // download a single attachment based from incident id and attachment id
        return axios.get(API_URL + `/incidents/${incidentId}/attachments/${attachmentId}`, {
            responseType: 'blob', // binary file
            headers: authHeader()
        })
            .then(response => {
                // create a URL for the file and return it:
                return window.URL.createObjectURL(new Blob([response.data]))
            })
            .catch(error => {
                console.error('Caught error fetching file. ', error)
                return null
            })
    }

    createAttachment(id, files) {
        const data = new FormData();
        for (const file of files) {
            if (file.size >= 2097152) {
                throw new Error('Die Datei ist zu groß. Die maximale Dateigrösse beträgt 2MB')
            }
            data.append('file[]', file);
        }

        return axios.post(API_URL + `/incidents/${id}/attachments`, data, {
            headers: authHeader()
        });
    }

    updateIncident(id, action, status = null) {
        const data = {
            action: action,
            processing: status
        };
        return axios.put(API_URL + `/incidents/${id}`, data, {
                headers: authHeader()
            }
        );
    }

    deleteUser(id) {
        return axios.delete(API_URL + `/users/${id}`, {headers: authHeader()});
    }
}

export default new UserService();

